import { ReactComponent as GridcoLogo } from "../../icons/gridco-logo.svg";

export default function GridcoHeading({ title }: { title: string }) {
  return (
    <div className="header flex items-center justify-between">
      <h1>{title}</h1>
      <div className="flex flex-row justify-center items-center space-x-2 ">
        <GridcoLogo width={"40px"} height={"60px"} />
        <h1 className="text-[#6F6D7C] text-[18px]">
          GRIDCO Power Analytics Center
        </h1>
      </div>
    </div>
  );
}
export function GridcoTitle() {
  return (
    <div className=" flex flex-row justify-center items-center space-x-2 ">
      <GridcoLogo width={"40px"} height={"60px"} />
      <h1 className="text-[#6F6D7C] text-[18px]">
        GRIDCO Power Analytics Center
      </h1>
    </div>
  );
}

interface FooterProps {
  source: string;
  note?: string;
}

export const GnaRuvnlFooter: React.FC<FooterProps> = ({ source, note }) => {
  return (
    <div className="gna-footer-container">
      <div className="flex justify-between">
        <p className="gna-footer-text">{source}</p>
        <p className="gna-footer-text">Powered by GNA Energy</p>
        {/* <p className="gna-footer-text">Beta Version</p> */}
      </div>
      {note && <p className="gna-footer-note">{note}</p>}
    </div>
  );
};
